import { render, staticRenderFns } from "./FeaturedCategoryArticles.vue?vue&type=template&id=2200d8e1&scoped=true&"
import script from "./FeaturedCategoryArticles.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategoryArticles.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCategoryArticles.vue?vue&type=style&index=0&id=2200d8e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200d8e1",
  null
  
)

export default component.exports